export default __webpack_public_path__ + "static/media/logo.8ba4e269.png";